export default {
    // 中
    zhCN: {
        menu: '菜单',
        menu_name: '菜单名称',
        menu_type: '菜单类型',
        menu_new: '菜单新增',
        menu_edit: '菜单编辑',
        icon: '图标',
        parent: '父级菜单',
        order_number: '排序',
        path: '路由地址',
        status: '菜单状态',
    },
    // 英
    enUS: {
        menu: 'Menu',
        menu_name: 'Menu name',
        menu_type: 'Menu type',
        menu_new: 'New menu',
        menu_edit: 'Modify menu',
        icon: 'Icon',
        parent: 'Parent',
        order_number: 'Order number',
        path: 'Path',
        status: 'Status',
    },
    // 德
    deDE: {
        menu: 'Menü',
        menu_name: 'Menüname',
        menu_type: 'Menütyp',
        menu_new: 'Neues Menü',
        menu_edit: 'Menü bearbeiten',
        icon: 'Symbol',
        parent: 'Eltern',
        order_number: 'Reihenfolge',
        path: 'Pfad',
        status: 'Status',
    },
    // 法
    frFR: {
        menu: 'Menu',
        menu_name: 'Nom du menu',
        menu_type: 'Type de menu',
        menu_new: 'Nouveau menu',
        menu_edit: 'Modifier le menu',
        icon: 'Icône',
        parent: 'Parent',
        order_number: 'Numéro de commande',
        path: 'Chemin',
        status: 'Statut',
    },
    // 意大利
    itIT: {
        menu: 'Menu',
        menu_name: 'Nome del Menu',
        menu_type: 'Tipo di Menu',
        menu_new: 'Nuovo Menu',
        menu_edit: 'Modifica Menu',
        icon: 'Icona',
        parent: 'Menu Principale',
        order_number: 'Ordinamento',
        path: 'Indirizzo del Percorso',
        status: 'Stato del Menu',
    },
    // 荷兰
    nlNL: {
        menu: 'Menu',
        menu_name: 'Menunaam',
        menu_type: 'Menutype',
        menu_new: 'Nieuw menu',
        menu_edit: 'Menu wijzigen',
        icon: 'Icoon',
        parent: 'Ouder',
        order_number: 'Bestelnummer',
        path: 'Pad',
        status: 'Status',
    },
    // 越南
    viVN: {
        menu: 'Menu',
        menu_name: 'Tên menu',
        menu_type: 'Loại menu',
        menu_new: 'Thêm mới menu',
        menu_edit: 'Chỉnh sửa menu',
        icon: 'Biểu tượng',
        parent: 'Menu cha',
        order_number: 'Số thứ tự',
        path: 'Địa chỉ đường dẫn',
        status: 'Trạng thái menu',
    },
    // 西班牙
    esES: {
        menu: 'Menú',
        menu_name: 'Nombre del menú',
        menu_type: 'Tipo de menú',
        menu_new: 'Añadir menú',
        menu_edit: 'Editar menú',
        icon: 'Ícono',
        parent: 'Menú principal',
        order_number: 'Ordenar',
        path: 'Dirección de ruta',
        status: 'Estado del menú',
    },
    // 葡萄牙
    ptBR: {
        menu: 'Menu',
        menu_name: 'Nome do menu',
        menu_type: 'Tipo de menu',
        menu_new: 'Novo menu',
        menu_edit: 'Editar menu',
        icon: 'Ícone',
        parent: 'Menu pai',
        order_number: 'Ordenação',
        path: 'Endereço do roteamento',
        status: 'Status do menu',
    },
    // 波兰
    plPL: {
        menu: 'Menu',
        menu_name: 'Nazwa menu',
        menu_type: 'Typ menu',
        menu_new: 'Nowe menu',
        menu_edit: 'Edycja menu',
        icon: 'Ikona',
        parent: 'Menu nadrzędne',
        order_number: 'Numer porządkowy',
        path: 'Ścieżka',
        status: 'Status',
    },
    // 土耳其
    trTR: {
        menu: 'Menü',
        menu_name: 'Menü İsmi',
        menu_type: 'Menü Türü',
        menu_new: 'Yeni Menü',
        menu_edit: 'Menüyi değiştir',
        icon: 'İşaretçi',
        parent: 'Ana menü',
        order_number: 'Sıra Numarası',
        path: 'Yol',
        status: 'Durum',
    },
    // 捷克语
    csCZ: {
        menu: 'Menu',
        menu_name: 'Název nabídky',
        menu_type: 'Typ nabídky',
        menu_new: 'Nová nabídka',
        menu_edit: 'Upravit nabídku',
        icon: 'Ikona',
        parent: 'Parent',
        order_number: 'Číslo objednávky',
        path: 'Cesta',
        status: 'Status',
    },
    // 匈牙利语
    huHU: {
        menu: 'Menü',
        menu_name: 'Menünév',
        menu_type: 'Menütípus',
        menu_new: 'Új menü',
        menu_edit: 'Menü módosítása',
        icon: 'Ikon',
        parent: 'Szülő',
        order_number: 'Megrendelésszám',
        path: 'Útvonal',
        status: 'Állapot',
    },
    // 俄罗斯语
    ruRU: {
        menu: 'Меню',
        menu_name: 'Название меню',
        menu_type: 'Тип меню',
        menu_new: 'Добавление меню',
        menu_edit: 'Редактирование меню',
        icon: 'Иконка',
        parent: 'Родительское меню',
        order_number: 'Сортировка',
        path: 'Адрес маршрута',
        status: 'Статус меню',
    },
    // 沙特阿拉伯 (阿拉伯语)
    arSA: {
        menu: 'القائمة',
        menu_name: 'اسم القائمة',
        menu_type: 'نوع القائمة',
        menu_new: 'إضافة قائمة جديدة',
        menu_edit: 'تحرير القائمة',
        icon: 'الأيقونة',
        parent: 'القائمة الأصلية',
        order_number: 'الترتيب',
        path: 'عنوان التوجيه',
        status: 'حالة القائمة',
    },
    // 保加利亚语
    bgBG: {
        menu: 'Меню',
        menu_name: 'Име на менюто',
        menu_type: 'Тип на менюто',
        menu_new: 'Ново меню',
        menu_edit: 'Редактиране на меню',
        icon: 'Икона',
        parent: 'Родителско меню',
        order_number: 'Подреждане',
        path: 'Път към маршрута',
        status: 'Статус на менюто',
    },
    // 丹麦语
    daDK: {
        menu: 'Menu',
        menu_name: 'Menunavn',
        menu_type: 'Menutype',
        menu_new: 'Ny menu',
        menu_edit: 'Redigér menu',
        icon: 'Ikon',
        parent: 'Overordnet menu',
        order_number: 'Sortering',
        path: 'Ruteadresse',
        status: 'Menustatus',
    },
    // 芬兰语
    fiFI: {
        menu: 'Valikko',
        menu_name: 'Valikon nimi',
        menu_type: 'Valikon tyyppi',
        menu_new: 'Uusi valikko',
        menu_edit: 'Muokkaa valikkoa',
        icon: 'Kuvake',
        parent: 'Ylävalikko',
        order_number: 'Lajittelu',
        path: 'Reitin osoite',
        status: 'Valikon tila',
    },
    // 繁体中文（台湾）
    zhTW: {
        menu: '選單',
        menu_name: '選單名稱',
        menu_type: '選單類型',
        menu_new: '新增選單',
        menu_edit: '編輯選單',
        icon: '圖示',
        parent: '父級選單',
        order_number: '排序',
        path: '路由地址',
        status: '選單狀態',
    },
    // 克罗地亚语
    hrHR: {
        menu: 'Izbornik',
        menu_name: 'Naziv izbornika',
        menu_type: 'Vrsta izbornika',
        menu_new: 'Novi izbornik',
        menu_edit: 'Uređivanje izbornika',
        icon: 'Ikona',
        parent: 'Nadređeni izbornik',
        order_number: 'Poredak',
        path: 'Putanja rute',
        status: 'Status izbornika',
    },
    // 拉脱维亚语
    lvLV: {
        menu: 'Izvēlne',
        menu_name: 'Izvēlnes nosaukums',
        menu_type: 'Izvēlnes veids',
        menu_new: 'Jauna izvēlne',
        menu_edit: 'Rediģēt izvēlni',
        icon: 'Ikona',
        parent: 'Vecāku izvēlne',
        order_number: 'Kārtas numurs',
        path: 'Maršruta adrese',
        status: 'Izvēlnes statuss',
    },
    // 立陶宛语
    ltLT: {
        menu: 'Meniu',
        menu_name: 'Meniu pavadinimas',
        menu_type: 'Meniu tipas',
        menu_new: 'Naujas meniu',
        menu_edit: 'Redaguoti meniu',
        icon: 'Piktograma',
        parent: 'Tėvinis meniu',
        order_number: 'Rūšiavimo numeris',
        path: 'Maršruto adresas',
        status: 'Meniu būsena',
    },
    // 罗马尼亚语
    roRO: {
        menu: 'Meniu',
        menu_name: 'Numele meniului',
        menu_type: 'Tipul meniului',
        menu_new: 'Adăugare meniu',
        menu_edit: 'Editare meniu',
        icon: 'Pictogramă',
        parent: 'Meniu părinte',
        order_number: 'Ordine',
        path: 'Adresă rută',
        status: 'Stare meniu',
    },
    // 挪威博克马尔语
    nbNO: {
        menu: 'Meny',
        menu_name: 'Menynavn',
        menu_type: 'Menytype',
        menu_new: 'Ny meny',
        menu_edit: 'Rediger meny',
        icon: 'Ikon',
        parent: 'Overordnet meny',
        order_number: 'Sorteringsnummer',
        path: 'Ruteadresse',
        status: 'Menystatus',
    },
    // 葡萄牙语（巴西）
    ptBX: {
        menu: 'Menu',
        menu_name: 'Nome do menu',
        menu_type: 'Tipo de menu',
        menu_new: 'Novo menu',
        menu_edit: 'Editar menu',
        icon: 'Ícone',
        parent: 'Menu pai',
        order_number: 'Ordenação',
        path: 'Endereço da rota',
        status: 'Status do menu',
    },
    // 瑞典语
    svSE: {
        menu: 'Meny',
        menu_name: 'Menynamn',
        menu_type: 'Menytyp',
        menu_new: 'Ny meny',
        menu_edit: 'Redigera meny',
        icon: 'Ikon',
        parent: 'Överordnad meny',
        order_number: 'Sorteringsordning',
        path: 'Ruttadress',
        status: 'Menystatus',
    },
    // 斯洛伐克语
    skSK: {
        menu: 'Ponuka',
        menu_name: 'Názov položky ponuky',
        menu_type: 'Typ položky ponuky',
        menu_new: 'Nová položka ponuky',
        menu_edit: 'Úprava položky ponuky',
        icon: 'Ikona',
        parent: 'Nadradená položka ponuky',
        order_number: 'Poradie',
        path: 'Adresa trasy',
        status: 'Stav položky ponuky',
    },
    // 斯洛文尼亚语
    slSI: {
        menu: 'Meni',
        menu_name: 'Ime menija',
        menu_type: 'Vrsta menija',
        menu_new: 'Nov meni',
        menu_edit: 'Urejanje menija',
        icon: 'Ikona',
        parent: 'Nadrejeni meni',
        order_number: 'Zaporedje',
        path: 'Naslov usmerjevalnika',
        status: 'Stanje menija',
    },
    // 泰语
    thTH: {
        menu: 'เมนู',
        menu_name: 'ชื่อเมนู',
        menu_type: 'ประเภทเมนู',
        menu_new: 'เพิ่มเมนูใหม่',
        menu_edit: 'แก้ไขเมนู',
        icon: 'ไอคอน',
        parent: 'เมนูหลัก',
        order_number: 'ลำดับ',
        path: 'ที่อยู่เส้นทาง',
        status: 'สถานะเมนู',
    },
    // 乌克兰语
    ukUA: {
        menu: 'Меню',
        menu_name: 'Назва меню',
        menu_type: 'Тип меню',
        menu_new: 'Нове меню',
        menu_edit: 'Редагувати меню',
        icon: 'Іконка',
        parent: 'Батьківське меню',
        order_number: 'Порядок сортування',
        path: 'Шлях маршруту',
        status: 'Стан меню',
    },
    // 希腊语
    elGR: {
        menu: 'Μενού',
        menu_name: 'Όνομα μενού',
        menu_type: 'Τύπος μενού',
        menu_new: 'Νέο μενού',
        menu_edit: 'Επεξεργασία μενού',
        icon: 'Εικονίδιο',
        parent: 'Γονικό μενού',
        order_number: 'Σειρά ταξινόμησης',
        path: 'Διεύθυνση διαδρομής',
        status: 'Κατάσταση μενού',
    },
    // 爱沙尼亚语
    etEE: {
        menu: 'Menüü',
        menu_name: 'Menüü nimi',
        menu_type: 'Menüü tüüp',
        menu_new: 'Uus menüü',
        menu_edit: 'Muuda menüüd',
        icon: 'Ikoon',
        parent: 'Ülemmenüü',
        order_number: 'Järjestus',
        path: 'Marsruudi aadress',
        status: 'Menüü olek',
    },
    // 哈萨克语
    kkKZ: {
        menu: 'Мәзір',
        menu_name: 'Мәзір атауы',
        menu_type: 'Мәзір түрі',
        menu_new: 'Жаңа мәзір',
        menu_edit: 'Мәзірді түзету',
        icon: 'Таңбаша',
        parent: 'Ата-ана мәзірі',
        order_number: 'Сұрыптау',
        path: 'Маршрут адресі',
        status: 'Мәзір күйі',
    },
    // 希伯来语
    heIL: {
        menu: 'תפריט',
        menu_name: 'שם התפריט',
        menu_type: 'סוג תפריט',
        menu_new: 'תפריט חדש',
        menu_edit: 'עריכת תפריט',
        icon: 'אייקון',
        parent: 'תפריט אב',
        order_number: 'מיון',
        path: 'כתובת נתב',
        status: 'סטטוס תפריט',
    },
};
